import {ReelSymbol} from '@fantasmagames/slot/src/modules/reels/spin/ReelSymbol';
import {SpineAnimation} from '@fantasmagames/core/src/display/SpineAnimation';
import {GameReelConstants} from 'src/reels/GameReelConstants';
import {Symbols} from 'src/reels/Symbols';
import {Spine} from '@fantasmagames/core/src/spine/Spine';

export class GameReelSymbol extends ReelSymbol {
	protected _winIndication: SpineAnimation;
	protected _idleAnimation: SpineAnimation;

	protected _oversizedLayer: PIXI.Container;

	protected _intenseIdleAnimationContainer: PIXI.Container;

	private _symbolMovedThroughLine: boolean = false;

	protected setupSymbol(): void {
	}

	protected setupLayersOrder(parentSym: PIXI.Container, background?: PIXI.Container, foreground?: PIXI.Container, spinningSymbol?: PIXI.Sprite): void {
		this._container = new PIXI.Container();
		this.addChild(this._container);
		this._intenseIdleAnimationContainer = new PIXI.Container();
		this._symbolContainer = new PIXI.Sprite();
		this._container.addChild(this._symbolContainer);

		this._symbolContainer.addChild(this._intenseIdleAnimationContainer);

		if (background) {
			this._symbolContainer.addChild(background);
		}
		this._symbolContainer.addChild(parentSym);
		if (foreground) {
			this._symbolContainer.addChild(foreground);
		}

		if (spinningSymbol) {
			this._symbolContainer.addChild(spinningSymbol);
			this._spinningSymbol = spinningSymbol;
		}

		this._symbol = parentSym;
		this._symbolBackground = background;
		this._symbolForeground = foreground;
	}

	public fixTopReelSymbol(): void {
		this.container.visible = true;

		if (this.positionOnReel >= 3) {
			this.container.visible = false;
		}
	}

	public fixTopReelSymbolBeforeNew(): void {
		this.container.visible = true;

		if (this.positionOnReel >= 3) {
			this.container.visible = false;
		}
	}

	protected hasWinIndication(): boolean {
		return this._symbolForeground.visible && !!this._winIndication;
	}

	public playStopAnimation(animationName: string): void {
		this._symbol.visible = false;
		this._stopAnimation = this._spineUtils.startSpineAnimationCreation(this.getIdleSpineName(), animationName, false)
			.container(this._symbolContainer)
			.position(GameReelConstants.getBottomSymbolSlot().width / 2, GameReelConstants.getBottomSymbolSlot().height / 2)
			.createAndStart();
	}

	public playRespinAttention(): void {
		this.removeStopAnimation();

		if (this.oversizedLayer) {
			this._symbol.visible = false;
			this.oversizedLayer.addChild(this);
			this._stopAnimation = this._spineUtils.startSpineAnimationCreation('RESPIN.json', 'ATTENTION', false)
				.container(this._symbolContainer)
				.position(GameReelConstants.getBottomSymbolSlot().width / 2, GameReelConstants.getBottomSymbolSlot().height / 2)
				.chainIdleAnimation('IDLE')
				.createAndStart();
		}
	}

	public playScatterBonusIdleAnimation(scatterIndex: number): void {
		this.removeStopAnimation();
		this.removeIdleAnimation();
		this._symbol.visible = false;
		const index: number = scatterIndex > 3 ? 3 : scatterIndex;
		this._idleAnimation = this._spineUtils.startSpineAnimationCreation('BONUS_SCATTER.json', `0${index}_IDLE`, true)
			.container(this._symbolContainer)
			.position(GameReelConstants.getBottomSymbolSlot().width / 2, GameReelConstants.getBottomSymbolSlot().height / 2)
			.createAndStart();
	}

	public playScatterBonusLanding(scatterIndex: number, cb: Function): void {
		this.removeStopAnimation();
		this._symbol.visible = false;
		const index: number = scatterIndex > 3 ? 3 : scatterIndex;
		this._stopAnimation = this._spineUtils.startSpineAnimationCreation('BONUS_SCATTER.json', `0${index}_LAND`, false)
			.container(this._symbolContainer)
			.position(GameReelConstants.getBottomSymbolSlot().width / 2, GameReelConstants.getBottomSymbolSlot().height / 2)
			.chainIdleAnimation(`0${index}_IDLE`)
			.onComplete(() => cb && cb())
			.createAndStart();
	}

	public removeStopAnimation(): void {
		if (this._stopAnimation) {
			this._spineUtils.stopAndDestroyAnimation(this._stopAnimation);
			this._stopAnimation = null;
		}
	}

	public addWinIndication(isRightToLeft: boolean): void {
		this._symbolForeground.visible = true;
		this._symbolBackground.visible = true;

		if (this.symbolType === Symbols.WR) {
			this.removeIdleAnimation();
			this.addIdleAnimation('IDLE_INTENSE');
		}

		this._winIndication = this._spineUtils.startSpineAnimationCreation('INITIAL_WIN.json', this.getWinIndictionAnimationName(isRightToLeft), false)
			.container(this._symbolForeground)
			.position(GameReelConstants.getBottomSymbolSlot().width / 2, GameReelConstants.getBottomSymbolSlot().height / 2)
			.createAndStart();

		const winIndicationBack: SpineAnimation =
			this._spineUtils.startSpineAnimationCreation('INITIAL_WIN_COVER.json', 'INITIAL_WIN', false)
				.container(this._symbolBackground)
				.position(GameReelConstants.getBottomSymbolSlot().width / 2, GameReelConstants.getBottomSymbolSlot().height / 2)
				.createAndStart();

		if (this.symbolType === Symbols.TOP_WR || this.symbolType === Symbols.WR) {
			this._spineUtils.setSkin((this._winIndication.container as Spine).skeleton, 'WILD');
			this._spineUtils.setSkin((winIndicationBack.container as Spine).skeleton, 'WILD');
		} else if (this.symbolType === Symbols.M1 || this.symbolType === Symbols.M2 || this.symbolType === Symbols.M3 || this.symbolType === Symbols.M4 || this.symbolType === Symbols.M5) {
			this._spineUtils.setSkin((this._winIndication.container as Spine).skeleton, 'HIGH');
			this._spineUtils.setSkin((winIndicationBack.container as Spine).skeleton, 'HIGH');
		} else {
			this._spineUtils.setSkin((this._winIndication.container as Spine).skeleton, 'LOW');
			this._spineUtils.setSkin((winIndicationBack.container as Spine).skeleton, 'LOW');
		}
	}

	public playWinRemoveAnimation(onComplete: Function): void {
		// INITIAL_WIN.json EXIT (on top)
		// INITAL_WIN_COVER EXIT (bottom)

		this._symbolBackground.visible = true;

		const winIndicationBack: SpineAnimation =
			this._spineUtils.startSpineAnimationCreation('INITIAL_WIN_COVER.json', 'EXIT', false)
				.onComplete(() => {
					this._symbolBackground.visible = false;
					onComplete && onComplete();
				})
				.container(this._symbolBackground)
				.position(GameReelConstants.getBottomSymbolSlot().width / 2, GameReelConstants.getBottomSymbolSlot().height / 2)
				.createAndStart();

		if (this.symbolType === Symbols.TOP_WR || this.symbolType === Symbols.WR) {
			this._spineUtils.setSkin((winIndicationBack.container as Spine).skeleton, 'WILD');
		} else if (this.symbolType === Symbols.M1 || this.symbolType === Symbols.M2 || this.symbolType === Symbols.M3 || this.symbolType === Symbols.M4 || this.symbolType === Symbols.M5) {
			this._spineUtils.setSkin((winIndicationBack.container as Spine).skeleton, 'HIGH');
		} else {
			this._spineUtils.setSkin((winIndicationBack.container as Spine).skeleton, 'LOW');
		}
	}

	protected getWinIndictionAnimationName(isRightToLeft: boolean): string {
		// MHNOTE: Animations are swapped due to rotation direction.
		return !isRightToLeft ? 'INITIAL_WIN_RIGHT_TO_LEFT' : 'INITIAL_WIN_LEFT_TO_RIGHT';
	}

	public addIdleAnimation(animationName?: string): void {
		this.removeStopAnimation();

		this._symbol.visible = false;

		this._idleAnimation = this._spineUtils.startSpineAnimationCreation(this.getIdleSpineName()
			, animationName ? animationName : 'IDLE', true)
			.container(animationName ? this._intenseIdleAnimationContainer : this._symbolContainer)
			.position(GameReelConstants.getSpecificRowSymbolSlot(this.index).width / 2
				, GameReelConstants.getSpecificRowSymbolSlot(this.index).height / 2)
			.createAndStart();
	}

	public removeIdleAnimation(): void {
		this._symbol.visible = true;

		if (this._idleAnimation) {
			this._spineUtils.stopAndDestroyAnimation(this._idleAnimation);
			this._idleAnimation = null;
		}
	}

	public removeWinIndication(): void {
		this._symbolForeground.visible = false;
		if (this._winIndication) {
			this._spineUtils.stopAndDestroyAnimation(this._winIndication);
			this._winIndication = null;
		}
	}

	protected getIdleSpineName(): string {
		switch (this.symbolType) {
			case Symbols.TOP_WR: {
				return 'TOP_WILD.json';
			}
			case Symbols.TOP_BN: {
				return 'TOP_BONUS.json';
			}
			case Symbols.TOP_RS: {
				return 'TOP_RESPIN.json';
			}
			case Symbols.RS: {
				return 'RESPIN.json';
			}
			case Symbols.WR: {
				return 'WILD.json';
			}
			default:
				break;
		}
	}

	public get symbolMovedThroughLine(): boolean {
		return this._symbolMovedThroughLine;
	}

	public set symbolMovedThroughLine(value: boolean) {
		this._symbolMovedThroughLine = value;
	}

	public shouldHaveRespinAttentionAnimation(): boolean {
		return this.symbolType === Symbols.RS && this.index >= 3;
	}

	public shouldHaveWildIdleAnimation(): boolean {
		return this.symbolType === Symbols.WR && this.index >= 3;
	}

	public shouldHaveScatterLandingAnimation(): boolean {
		return (this.symbolType === Symbols.BN || this.symbolType === Symbols.TOP_BN) && this.index >= 3;
	}

	public shouldHaveSpecialLandingAnimation(): boolean {
		return this.shouldHaveRespinAttentionAnimation() || this.shouldHaveScatterLandingAnimation();
	}

	public makeCleanup(): void {
		this.removeIdleAnimation();
		this.removeStopAnimation();
		this.removeWinIndication();
	}

	public get oversizedLayer(): PIXI.Container {
		return this._oversizedLayer;
	}

	public set oversizedLayer(value: PIXI.Container) {
		this._oversizedLayer = value;
	}
}



// WEBPACK FOOTER //
// ./src/avalanche/GameReelSymbol.ts